import { jsx as _jsx } from "react/jsx-runtime";
import ErrorPage from "./ErrorPage";
export default function NotFound() {
    return (_jsx(ErrorPage, { title: "Not Found", children: "This page does not exist or you do not have access to it." }));
}
